'use strict';

module.exports = {
    root: 'root',
    pages: 'pages',
    supplierNotes: 'supplierNotes',
};
